<table class="table table-hover">
    <thead>
      <tr>
        <ng-container *ngFor="let head of headers; let i = index">
          <th class="border-top-0 pb-1 small font-weight-bold " scope="col" (click)="modifyOrder(i)">
            <div class="row">
              <div class="col-12">
                <input type="button" 
                  *ngIf="head.is_sortable"
                  [id]="i" 
                  class="order-button"
                  [ngClass]="{'asc': head.current_order === 1, 'desc' : head.current_order === 2 }"
                 >
                 <label class="ml-3 mb-2">{{head.label}}</label>   
              </div>
            </div>
          </th>
        </ng-container>
      </tr>
    </thead>
    <tfoot *ngIf="sizeData > 0; else sinPaginado">
      <tr>
        <td colspan="100%">
          <ngb-pagination class="d-flex justify-content-center" [collectionSize]="sizeData" [pageSize]="pageSize"
            (pageChange)="onPaginado($event)" [(page)]="page" [maxSize]="5" [rotate]="true" [boundaryLinks]="true" size="sm"></ngb-pagination>
        </td>
      </tr>
    </tfoot>
    <ng-template #sinPaginado>
      <tfoot>
        <label class="text-muted" *ngIf="paginar">Sin registros</label>
      </tfoot>
    </ng-template>
    <ng-content *ngIf="!body; else dataParametro"></ng-content>
    <ng-template #dataParametro>
      <tbody>
        <tr *ngFor="let value of body; let i = index" (click)="selectRow(value)" [ngClass]="{'bg-primary text-white': i === body.indexOf(selectData)}">
          <ng-container *ngFor="let dato of getEntries(value)">
            <td>{{dato}}</td>
          </ng-container>
        </tr>
      </tbody>
    </ng-template>
  </table>
  